// removed by extract-text-webpack-plugin
module.exports = {"pageContainer":"_11Urg2gVfvsXqlnzVK8as6","copyrights":"lRhraN_Rsh0kOeuw5_5-l","sectionToggle":"_2c-ktJLzRYSp0FKWFhMvIR","withToggleHint":"_2ap3SV2jvifBmea7d5TPpJ","checkboxRow":"kixRQO4J1nEJqKpuJmTmt","toggleHint":"_11YQ-I0DmyfgLvd1QVBVwx","listRow":"_1CzOtjasn5yByGb9453Ze6"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Project/ProjectInfo/ProjectInfo.scss
// module id = 1367
// module chunks = 1